import React, { useState } from 'react';
import { motion } from 'framer-motion';
import '../styles/BonusBlock.css';

const BonusBlock = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const bonuses = [
    {
      image: '/images/bonus_1.jpg',
      title: 'Asesor EA LODFX – Configuración guiada',
      description: 'Instalación + uso correcto del gestor de riesgo',
    },
    {
      image: '/images/bonus_2.jpg',
      title: 'PDF Multiplicación Inteligente LODFX',
      description: 'Cómo escalar sin martingala ni locuras',
    },
    {
      image: '/images/bonus_3.jpg',
      title: 'PDF de nivelación para principiantes',
      description: 'Para que no te pierdas si estás empezando',
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, x: -30 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.5, ease: 'easeOut' },
    },
  };

  return (
    <div className="bonus-block">
      <div className="bonus-header">
        <h3 className="bonus-subtitle">🎁 Bonos de acceso (solo para los primeros inscritos)</h3>
        <p className="bonus-intro">Bonos incluidos solo para los primeros en asegurar su cupo</p>
      </div>

      <motion.div
        className="bonus-list"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        {bonuses.map((bonus, index) => (
          <motion.div
            key={index}
            className="bonus-item"
            variants={itemVariants}
          >
            <img 
              src={bonus.image} 
              alt={bonus.title} 
              className="bonus-image"
              onClick={() => setSelectedImage(bonus.image)}
            />
            <div className="bonus-content">
              <h4 className="bonus-title">{bonus.title}</h4>
              <p className="bonus-description">{bonus.description}</p>
            </div>
          </motion.div>
        ))}
      </motion.div>

      <div className="bonus-note">
        <p className="bonus-note-text">
          Bonos válidos únicamente para los primeros 100 inscritos.<br />
          No se entregan después.
        </p>
      </div>

      {selectedImage && (
        <motion.div 
          className="bonus-modal-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={() => setSelectedImage(null)}
        >
          <motion.div 
            className="bonus-modal-content"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            onClick={(e) => e.stopPropagation()}
          >
            <button 
              className="bonus-modal-close"
              onClick={() => setSelectedImage(null)}
            >
              ✕
            </button>
            <img src={selectedImage} alt="Bonus" className="bonus-modal-image" />
          </motion.div>
        </motion.div>
      )}
    </div>
  );
};

export default BonusBlock;
